import { PositioningService } from '../../../services/positioning.service';
import {
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    ElementRef, inject,
    Input,
    OnDestroy,
    OnInit,
    ViewChild, ViewContainerRef,
    ViewRef
} from '@angular/core';
import { PageTextBoxesComponent } from './book-feature/page-text-boxes/page-text-boxes.component';
import { PageCanvasComponent } from './book-feature/page-canvas/page-canvas.component';
import { PageBookFeatures } from '../../../models/page-book-features';
import { SearchResult } from '../../../models/search-result';
import { TextBox } from '../../../models/text-box';
import { MoveableBookFeature } from '../../../models/moveable-book-feature';
import { PageDrawing } from '../../../models/page-drawing';
import _ from 'lodash';
import { Position } from '../../../models/position';
import { Observable, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PageFavoriteService } from '../../../services/page-favorite.service';
import { BookFeatureActivationService } from '../../../services/book-feature-activation.service';
import { PageService } from '../../../services/page.service';
import { PageTextService } from '../../../services/page-text.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { CommunicationService } from '../../../services/communication.service';
import { Page } from '../../../models/page';
import { BookFeatureService } from '../../../services/book-feature.service';
import { SearchService } from '../../../services/search.service';
import { QuickLinkService } from '../../../services/quick-link.service';
import { PageEditModeFactory } from '../../../utils/page-edit-modes/page-edit-mode-factory';
import { SidebarService } from '../../../services/sidebar.service';
import { ZoomService } from '../../../services/zoom.service';
import { Context, QuickLinkFactory } from '../../../models/factories/quick-link-factory';
import { PageEditMode } from '../../../utils/page-edit-modes/page-edit-mode';
import { DrawEditMode } from '../../../utils/page-edit-modes/draw-edit-mode';
import { SelectionPageEditMode } from '../../../utils/page-edit-modes/selection-page-edit-mode';
import { TextSelection } from '../../../models/text-selection';
import { EditMoveableBookFeatureEvent } from '../../../utils/events/edit-moveable-book-feature-event';
import { Rect } from '../../../models/rect';
import { BookFeatureComponent } from './book-feature/book-feature.component';
import { QuickLinkUtils } from '../../../utils/quick-link-utils';
import { TermLookUpEvent } from '../../../utils/events/term-look-up-event';
import { DictionaryService } from '../../../services/dictionary.service';
import { TextCopy } from '../../../models/text-copy';
import { CopyingPageEditMode } from '../../../utils/page-edit-modes/copying-page-edit-mode';
import { WhiteboardDrawingsService } from '@lemberger/whiteboards';
import { map } from 'rxjs/operators';
import { WhiteboardEditMode } from '../../../utils/page-edit-modes/whiteboard-edit-mode';
import { WhiteboardDrawing } from '../../../models/whiteboard-drawing';
import $ from 'jquery';
import { CrudService } from '../../../services/crud.service';
import { TechnicalFeature } from '@lemberger/lemberger-am';

@Component({
    template: ''
})
export abstract class AbstractPageComponent implements OnInit, OnDestroy {

    pageFavoriteService: PageFavoriteService;
    bookFeatureActivationService: BookFeatureActivationService;
    pageService: PageService;
    pageTextService: PageTextService;
    applicationStateService: ApplicationStateService;
    crudService = inject(CrudService);

    @Input() pagesContainer: JQuery;
    @Input() page: Page;
    @Input() isFirstPage: boolean;

    protected childHost: ViewContainerRef;
    @ViewChild('childHost', {read: ViewContainerRef})
    set setterChildHost(vcr: ViewContainerRef) {
        if (!vcr) {
            return;
        }

        this.childHost = vcr;
    };
    imgSrc: string;
    @Input() imageWidth: number;
    @Input() imageHeight: number;
    bookFeatures: PageBookFeatures;
    searchResults: Array<SearchResult>;
    whiteboards$: Observable<Array<WhiteboardDrawing>>;
    textBoxes: Array<TextBox>;
    newMoveableBookFeature: MoveableBookFeature | PageDrawing;
    searchedTermPosition: Position;
    protected communicationService: CommunicationService;
    protected positioningService: PositioningService;
    protected bookFeatureService: BookFeatureService;
    protected searchService: SearchService;
    protected quickLinkService: QuickLinkService;
    protected componentFactoryResolver: ComponentFactoryResolver;
    protected pageEditModeFactory: PageEditModeFactory;
    protected changeDetectorRef: ChangeDetectorRef;
    protected sidebarService: SidebarService;
    protected zoomService: ZoomService;
    protected dictionaryService: DictionaryService;
    protected quickLinkFactory: QuickLinkFactory;
    protected whiteboardService: WhiteboardDrawingsService;
    @ViewChild('container', { static: true }) protected container: ElementRef;
    @ViewChild('img') protected img: ElementRef;
    @ViewChild(PageTextBoxesComponent) protected pageTextBoxes: PageTextBoxesComponent;
    @ViewChild(PageCanvasComponent) protected pageCanvasComponent: PageCanvasComponent;
    protected $container: JQuery;
    protected dataFetchingTimeoutId;
    protected bookFeatureSubscription: Subscription;
    protected dataChangedSubscription: Subscription;
    protected zoomLevelChangedSubscription: Subscription;
    protected searchSubscription: Subscription;
    protected highlightTextboxesSubscription: Subscription;
    protected toggledReadspeakerSubscription: Subscription;
    protected termLookUpSubcription: Subscription;
    protected detectChangesSubscription: Subscription;
    protected readspeakerVisibilityChangedSubscription: Subscription;
    protected sidebarChangedSubscription: Subscription;
    private debouncedGetTextBoxByEvent: (($event) => void) & _.Cancelable;

    protected constructor() {
        this.debouncedGetTextBoxByEvent = _.debounce(this.getTextBoxByEvent, 500);
    }

    /**
     * Called on component destruction.
     */
    ngOnDestroy(): void {

        if (this.dataFetchingTimeoutId) {
            clearTimeout(this.dataFetchingTimeoutId);
            this.img.nativeElement.src = '';
            this.img.nativeElement.onerror = null;
        }

        this.unsubscribeSubscriptions();
    }

    ngOnInit(): void {
        this.whiteboards$ = this.whiteboardService.whiteboardDrawingsMap$.pipe(
            map(allPagesMap => {
                if (!allPagesMap.has(this.page.id)) {
                    return [];
                }

                return allPagesMap.get(this.page.id).map(ele => {
                    const casted = new WhiteboardDrawing();
                    Object.assign(casted, ele);

                    return casted;
                });
            }));
    }

    /**
     * Handler for mousedown/touchstart event.
     * - Sets page and redirects event to current edit mode
     *
     * @param {Event} $event
     */
    onMouseDown($event): boolean {
        const editMode: PageEditMode = this.applicationStateService.pageEditMode;
        this.applicationStateService.preventPanning = $event.srcElement?.classList.contains('note-editable');

        if (!editMode || editMode.getStatus() > 1) {
            return true;
        }

        if (!(editMode instanceof DrawEditMode || editMode instanceof SelectionPageEditMode)) {

            $event.preventDefault();
            $event.stopPropagation();
        } else if (!this.bookFeatures.pageDrawing) {
            this.createPageDrawing();
        }

        const target = event.target as HTMLElement;
        const isDropdown = target?.closest('.dropdown-toggle, .dropdown');
        if(isDropdown === null) {
            editMode.setPage(this);
            editMode.onMouseDown($event);
            this.newMoveableBookFeature = editMode.getResult();
        }

        if (this.newMoveableBookFeature && this.newMoveableBookFeature instanceof Rect) {
            this.addNewMoveableBookFeatureComponent(this.newMoveableBookFeature);
        }

        return true;
    }

    /**
     * Handler for mousemove/touchmove event.
     * - Redirects event to current edit mode
     *
     * @param {Event} $event
     */
    onMouseMove($event): boolean {
        const editMode: PageEditMode = this.applicationStateService.pageEditMode;
        if (!editMode) {
            return true;
        }

        if (!(editMode instanceof DrawEditMode || editMode instanceof SelectionPageEditMode)) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        if (!editMode.getPage()) {
            editMode.setPage(this);
        }

        editMode.onMouseMove($event);
        this.communicationService.announceDetectChanges();
        this.newMoveableBookFeature = editMode.getResult();

        return false;
    }

    /**
     * Handler for mouseup/touchend event.
     * - Redirects event to current edit mode.
     *
     * @param {Event} $event
     */
    onMouseUp($event): boolean {
        this.applicationStateService.preventSwipe = false;
        this.applicationStateService.preventPanning = false;
        const editMode: PageEditMode = this.applicationStateService.pageEditMode;
        if (!editMode) {
            return true;
        }

        if (!(editMode instanceof DrawEditMode ||
            editMode instanceof SelectionPageEditMode ||
            editMode instanceof CopyingPageEditMode ||
            editMode instanceof WhiteboardEditMode)) {
            $event.preventDefault();
            $event.stopPropagation();
        }

        editMode.onMouseUp($event);

        if (!(this.newMoveableBookFeature instanceof PageDrawing || editMode instanceof CopyingPageEditMode)) {
            this.applicationStateService.pageEditMode = undefined;
        }

        if (this.newMoveableBookFeature instanceof TextSelection) {
            this.newMoveableBookFeature = undefined;
            this.applicationStateService.pageEditMode = this.pageEditModeFactory.createTextSelectionPageEditMode();
            const event = new EditMoveableBookFeatureEvent();
            event.moveableBookFeature = new TextSelection();
            this.applicationStateService.isPageEditable = true;
            this.communicationService.announceMoveableBookFeatureEdit(event);
        } else if (this.newMoveableBookFeature instanceof Rect) {
            this.newMoveableBookFeature = undefined;
        }

        return true;
    }

    /**
     * Get the container of this page.
     *
     * @returns {JQuery}
     */
    getContainer(): JQuery {
        return this.$container;
    }

    onPress(textBox: TextBox): void {

        if (this.applicationStateService.isPageEditable || this.applicationStateService.pageEditMode) {
            return;
        }

        // No content available.
        if (!textBox.content ||
            !environment.features.dictionaryActivated ||
            this.applicationStateService.isOfflineModeEnabled ||
            this.applicationStateService.pageEditMode !== undefined) {
            return;
        }

        const prev = this.getPreviousText(textBox);
        const following = this.getFollowingText(textBox);
        const searchTerm = prev.text + textBox.content + following.text;

        const termLookUpEvent = new TermLookUpEvent();
        termLookUpEvent.searchTerm = searchTerm;
        termLookUpEvent.startBox = prev.box;
        termLookUpEvent.endBox = following.box;

        this.communicationService.announceTermLookUp(termLookUpEvent);
    }

    onTap($event): void {
        this.debouncedGetTextBoxByEvent($event);
    }

    protected initSubscriptions(): void {
        // this.initSidebarChangedSubscription();
        this.initBookFeatureSubscription();
        this.initDataChangedSubscription();
        this.initHighlightTextboxesSubscription();
        this.initTermLookUpSubcription();
        this.initZoomLevelChangedSubscription();
        this.initSearchSubscription();
        this.initToggledReadspeakerSubscription();
        this.initReadspeakerVisibilityChangedSubscription();
        this.initDetectChangesSubscription();
    }

    protected initBookFeatureSubscription(): void {
        this.bookFeatureSubscription = this.communicationService.editMoveableBookFeatureAnnounced$.subscribe(event => {
            this.newMoveableBookFeature = event.moveableBookFeature;

            if (this.newMoveableBookFeature instanceof Rect) {
                this.applicationStateService.pageEditMode = this.pageEditModeFactory.createRectPageEditMode();
            }

            if (this.newMoveableBookFeature instanceof TextSelection) {
                this.applicationStateService.pageEditMode = this.pageEditModeFactory.createTextSelectionPageEditMode();
            }

            if (this.newMoveableBookFeature instanceof TextCopy) {
                this.applicationStateService.pageEditMode = this.pageEditModeFactory.createTextCopyPageEditMode();
            }

            if (this.newMoveableBookFeature instanceof PageDrawing) {
                this.applicationStateService.pageEditMode =
                    this.pageEditModeFactory.createDrawEditMode(this.newMoveableBookFeature as PageDrawing);

                if (!this.bookFeatures.pageDrawing) {
                    this.createPageDrawing();
                }
            }
        });
    }

    protected initDataChangedSubscription(): void {
        this.dataChangedSubscription = this.communicationService.bookFeatureDataChangedAnnouncedSource$.subscribe(event => {

            if (!event.pageId || event.pageId === this.page.id) {
                if (event.cacheOnly) {
                    this.fetchCachedData();
                } else {
                    this.fetchData();
                }
            }
        });
    }

    protected initHighlightTextboxesSubscription(): void {
        this.highlightTextboxesSubscription = this.communicationService.highlightTextboxesAnnounced$.subscribe(() => {
            this.detectChanges();
            this.fetchTextData();
            this.highlightSelectedBoxes();
        });
    }

    protected initTermLookUpSubcription(): void {
        this.termLookUpSubcription = this.communicationService.termLookUpAnnounced$.subscribe(termLookUpEvent => {
            const dictElementSelector = '#dictionaryPopoverAnchor';
            if (this.searchedTermPosition) {
                //@ts-ignore
                bootstrap.Popover.getOrCreateInstance(dictElementSelector).dispose();
            }
            $('.popover').remove();

            if (!termLookUpEvent) {
                this.searchedTermPosition = undefined;
                this.detectChanges();

                return;
            }

            if (termLookUpEvent.startBox.pageId === this.page.id) {
                this.crudService.logDirect(TechnicalFeature.Dictionary);

                this.searchedTermPosition = new Position();
                this.searchedTermPosition.x = termLookUpEvent.startBox.position.x;
                this.searchedTermPosition.y = termLookUpEvent.startBox.position.y;
                this.searchedTermPosition.w = Math.max(0, termLookUpEvent.endBox.position.x +
                    termLookUpEvent.endBox.position.w -
                    termLookUpEvent.startBox.position.x);
                this.searchedTermPosition.h = termLookUpEvent.startBox.position.h;
                const popOverArrowPosition = this.searchedTermPosition.y > 50 ? 'top' : 'bottom';
                setTimeout(() => {
                    ($(dictElementSelector) as any).attr('data-bs-content', 'Lade Daten...');
                    ($(dictElementSelector) as any).attr('data-bs-placement', popOverArrowPosition);

                    //@ts-ignore
                    const popover = new bootstrap.Popover(dictElementSelector);
                    popover.show();

                    //($(dictElementSelector) as any).popover('show');
                    //const popover = $(dictElementSelector).data('bs.popover');
                    //this.calculatePopupPosition(popover, popOverArrowPosition);
                    const searchTerm = termLookUpEvent.searchTerm;
                    this.dictionaryService.getEntryByWord(searchTerm)
                        .then(value => {
                            const topEntry = value[0];

                            let html = '';
                            if (topEntry) {

                                html = `<h5 class="modal-title">${topEntry.fullHeadword}</h5>`;

                                html = html.concat('<ul>');
                                topEntry.texts.forEach(text => {
                                    html = html.concat('<li class="dict-texts">');
                                    if (text.header) {
                                        html = html.concat(`<div class="dict-text">${text.header}</div>`);
                                    }
                                    html = html.concat('<ul class="dict-definitions">');
                                    text.definitions.forEach(definition => {
                                        html = html.concat(`<div class="dict-definition">${definition}</div>`);
                                    });
                                    html = html.concat('</ul>');
                                    html = html.concat('</li>');
                                });
                                html = html.concat('</ul>');
                                // eslint-disable max-len
                                html = html.concat('<div class="footer">' +
                                    '<div>Das Wörterbuch dient dem Verständnis und kann Übersetzungsfehler beinhalten.</div>' +
                                    '<div>© PONS GmbH, Stuttgart, 2020 Alle Reche vorbehalten.</div>' +
                                    '</div>');
                            }

                            ($(dictElementSelector) as any).attr('data-bs-content', html);

                            //@ts-ignore
                            bootstrap.Popover.getOrCreateInstance(dictElementSelector).dispose();
                            // @ts-ignore
                            const popover = new bootstrap.Popover(dictElementSelector);
                            popover.show();
                            // $(popover.tip).addClass(popOverArrowPosition);
                            // this.calculatePopupPosition(popover, popOverArrowPosition);

                            $('.popover').on('wheel scroll', ($event => {
                                $event.stopPropagation();
                            }));

                        })
                        .catch(err => {
                            const errMsg = `Kein Eintrag zu \"${searchTerm}\" gefunden.`;
                            ($(dictElementSelector) as any).attr('data-bs-content', errMsg);

                            //@ts-ignore
                            bootstrap.Popover.getOrCreateInstance(dictElementSelector).dispose();
                            // @ts-ignore
                            const popover = new bootstrap.Popover(dictElementSelector);
                            popover.show();

                            //$(popover.tip).addClass(popOverArrowPosition);
                            //this.calculatePopupPosition(popover, popOverArrowPosition);
                        });

                }, 50);

            } else {
                this.searchedTermPosition = undefined;
            }
            this.detectChanges();
        });
    }

    protected initZoomLevelChangedSubscription(): void {
        this.zoomLevelChangedSubscription = this.communicationService.zoomLevelChangedAnnouncedSource$.subscribe(() => {

            if (this.applicationStateService.zoomLevel > environment.minZoomLevel &&
                this.imgSrc !== this.page.zoomImage.url) {

                const newImg = new Image();
                newImg.onload = () => {
                    this.setImageSrc();
                };

                newImg.src = this.page.zoomImage.url;
            }

            if (this.searchedTermPosition) {
                const dictElementSelector = '#dictionaryPopoverAnchor';
                //@ts-ignore
                bootstrap.Popover.getOrCreateInstance(dictElementSelector).update();
                // const popOverArrowPosition = this.searchedTermPosition.y > 50 ? 'top' : 'bottom';
                // this.calculatePopupPosition(popover, popOverArrowPosition);
            }
        });
    }

    protected initSearchSubscription(): void {
        this.searchSubscription = this.communicationService.searchChangeAnnounced$
            .subscribe(() => {
                this.fetchSearchData();
            });
    }

    protected initToggledReadspeakerSubscription(): void {
        this.toggledReadspeakerSubscription = this.communicationService.readspeakerVisibilityToggledSource$.subscribe(() => {
            this.fetchCachedData();
        });
    }

    protected initDetectChangesSubscription(): void {
        this.detectChangesSubscription = this.communicationService.detectChangesAnnounced$.subscribe(() => {
            this.detectChanges();
        });
    }

    protected initReadspeakerVisibilityChangedSubscription(): void {
        this.readspeakerVisibilityChangedSubscription = this.communicationService.readspeakerVisibilityToggledSource$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });
    }

    protected unsubscribeSubscriptions(): void {
        this.bookFeatureSubscription.unsubscribe();
        this.dataChangedSubscription.unsubscribe();
        this.zoomLevelChangedSubscription.unsubscribe();
        this.searchSubscription.unsubscribe();
        this.highlightTextboxesSubscription.unsubscribe();
        this.toggledReadspeakerSubscription.unsubscribe();
        this.termLookUpSubcription.unsubscribe();
        this.detectChangesSubscription.unsubscribe();
        this.readspeakerVisibilityChangedSubscription.unsubscribe();
        // this.sidebarChangedSubscription.unsubscribe();
    }

    protected setImageSrc(): void {

        const threshold: number = environment.minZoomLevel * 1.25;
        if (this.applicationStateService.zoomLevel > environment.minZoomLevel * threshold
            && this.imgSrc !== this.page.zoomImage.url) {
            this.imgSrc = this.page.zoomImage.url;
        }

        if (this.applicationStateService.zoomLevel <= threshold &&
            this.imgSrc !== this.page.image.url) {
            this.imgSrc = this.page.image.url;
        }
    }

    protected addNewMoveableBookFeatureComponent(moveableBookFeature: MoveableBookFeature): void {
        if (!this.childHost) {
            return;
        }

        this.childHost.clear();
        const componentRef = this.childHost.createComponent(moveableBookFeature as any);
        (componentRef.instance as BookFeatureComponent).moveableBookFeature = moveableBookFeature;
        (componentRef.instance as BookFeatureComponent).page = this.page;
    }

    protected createPageDrawing(): void {
        const newPageDrawing = new PageDrawing();
        newPageDrawing.pageId = this.page.id;
        this.bookFeatures.pageDrawing = newPageDrawing;
    }

    protected detectChanges(): void {
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.reattach();
            this.changeDetectorRef.detectChanges();
        }
    }

    /**
     * Tests the QuickLinks if they are available
     */
    protected fetchSolutionQuickLinksAndDropdownPossition(): void {
        this.bookFeatures.quickLinks.all().forEach(quickLink => {
            const context = new Context();
            context.page = this.page;
            context.bookId = +this.applicationStateService.bookId;

            if (this.quickLinkService.isBigEnough(quickLink.position) &&
                this.applicationStateService.bookConfig.displaySolutions &&
                this.applicationStateService.userData.isTeacher &&
                (!quickLink.combinedLink || quickLink.combinedLink.indexOf('help') !== 0) &&
                this.page.index >= this.applicationStateService.bookConfig.firstPage &&
                QuickLinkUtils.checkQuickLinkForSolution(quickLink, this.applicationStateService.bookConfig.quickLinkPrefix)) {

                quickLink.solutionLink = this.quickLinkFactory
                    .createSolutionQuickLink(quickLink, this.imageWidth, this.imageHeight, context);
            }
            quickLink.dropdownPossition = this.quickLinkFactory
                .getDropdownPossition(quickLink, this.imageWidth, this.imageHeight, context);
        });
        this.detectChanges();
    }

    protected fetchData(): void {

        this.bookFeatureService.getCachedBookFeaturesOfPage2(this.page.index)
            .then(bookFeatures => {

                this.bookFeatures = bookFeatures;
                this.fetchTextData();
            });
    }

    protected fetchCachedData(): Promise<any> {

        if (this.applicationStateService.pageEditMode instanceof DrawEditMode) {
            this.createPageDrawing();
        }

        return new Promise(resolve => {

            this.bookFeatureService.getCachedBookFeaturesOfPage2(this.page.index)
                .then(bookFeatures => {

                    _.extend(this.bookFeatures, bookFeatures);
                    this.detectChanges();

                    if (this.childHost) {
                        this.childHost.clear();
                    }

                    resolve(null);
                });
        });
    }

    protected fetchTextData(): void {

        if (!this.bookFeatureActivationService.textSelectionsVisible) {
            return;
        }

        this.pageTextService.getPageTextsOfPage(this.page.selections, this.page)
            .then(textBoxes => {

                this.textBoxes = textBoxes;
                this.pageTextBoxes.setTextBoxes(textBoxes);

                this.pageTextService.getTextSelectionsOfPage(this.page.id, textBoxes)
                    .then(textSelections => {

                        this.bookFeatures.textSelections = textSelections;
                        // const t1 = performance.now();
                        this.pageTextBoxes.triggerChangeDetection();
                        // console.log(performance.now() - t1);

                        this.highlightSelectedBoxes();
                        this.detectChanges();
                        if (this.childHost) {
                            this.childHost.clear();
                        }
                    });
            });
    }

    /**
     * get search results of actual page and store them
     */
    protected fetchSearchData(): void {
        this.searchService.getSearchResultsOfPage(this.page.index)
            .then(results => {
                this.searchResults = results;
            });
    }

    protected highlightSelectedBoxes(): void {
        if (this.bookFeatures.textSelections) {
            this.bookFeatures.textSelections.forEach(selection => {
                this.pageTextService.highlightTextBoxesOfSelection(selection, this.textBoxes, this.page.id);
            });
        }
    }

    protected updateCanvas(): void {
        if (this.pageCanvasComponent) {
            this.pageCanvasComponent.scaleCanvas(this.imageWidth, this.imageHeight);
        }
    }

    private getPreviousText(textBox: TextBox): { text: string; box: TextBox } {
        const startIndex = textBox.index;
        let currentIndex = startIndex - 1;
        let prevText = '';

        while (currentIndex >= 0 && this.isValidCharacter(this.textBoxes[currentIndex], textBox)) {
            prevText = this.textBoxes[currentIndex].content + prevText;
            currentIndex--;
        }

        return { text: prevText, box: this.textBoxes[currentIndex + 1] };
    }

    private getFollowingText(textBox: TextBox): { text: string; box: TextBox } {
        const startIndex = textBox.index;
        let currentIndex = startIndex + 1;
        let followingText = '';

        while (currentIndex < this.textBoxes.length && this.isValidCharacter(this.textBoxes[currentIndex], textBox)) {
            followingText = followingText + this.textBoxes[currentIndex].content;
            currentIndex++;
        }

        return { text: followingText, box: this.textBoxes[currentIndex - 1] };
    }

    private isValidCharacter(textBox: TextBox, startTextBox: TextBox): boolean {
        return textBox.content.match('[0-9a-zA-ZäöüÄÖÜß]') != null &&
            (Math.round(textBox.position.y) + Math.round(textBox.position.h) -
                Math.round(startTextBox.position.y) - Math.round(startTextBox.position.h) === 0);
    }

    private getTextBoxByEvent($event): void {
        if ($event.srcEvent) {
            $event.srcEvent.stopPropagation();
        }

        if ($event.tapCount === 1 && !this.applicationStateService.pageEditMode && !this.applicationStateService.isPageEditable) {
            const xOffset = $event.offsetX || $event.srcEvent.offsetX;
            const yOffset = $event.offsetY || $event.srcEvent.offsetY;

            const textBox = _.find(this.textBoxes, textBox => {
                return textBox.position.x / 100 * this.imageWidth <= xOffset &&
                    xOffset <= (textBox.position.x / 100 + textBox.position.w / 100) * this.imageWidth &&
                    textBox.position.y / 100 * this.imageHeight <= yOffset &&
                    yOffset <= (textBox.position.y / 100 + textBox.position.h / 100) * this.imageHeight;
            });
            if (textBox && textBox.content) {
                this.onPress(textBox);
            } else {
                this.clearPopover();
            }
        } else {
            this.clearPopover();
        }
    }

    // private calculatePopupPosition(popover: any, popOverArrowPosition: string): void {
    //     const widthInProcent = $(popover.tip).width() / (this.imageWidth / 100);
    //
    //     let leftPosition = this.searchedTermPosition.x + this.searchedTermPosition.w / 2 - widthInProcent / 2;
    //
    //     $('.popover .popover-arrow').css('transform', `translateX(${0}px)`);
    //     const initLeftPosition = leftPosition;
    //     const minDistanceToPageEdge = 1;
    //
    //     leftPosition = Math.max(minDistanceToPageEdge,
    //       this.searchedTermPosition.x + this.searchedTermPosition.w / 2 - widthInProcent / 2);
    //
    //     if (leftPosition + widthInProcent > 100) {
    //         leftPosition = 100 - widthInProcent - minDistanceToPageEdge;
    //     }
    //
    //     const diff = (leftPosition - initLeftPosition);
    //     if (Math.abs(diff) > 1) {
    //         const translate = this.imageWidth * -diff / 100;
    //         $('.popover .popover-arrow').css('transform', `translateX(${translate}px)`);
    //     }
    //
    //     $(popover.tip).css('left',
    //       `${leftPosition}%`);
    //
    //     if (popOverArrowPosition === 'bottom') {
    //         $(popover.tip).css('top', `${this.searchedTermPosition.y + this.searchedTermPosition.h}%`);
    //     } else {
    //         const heightInProcent = $(popover.tip).height() / (this.imageHeight / 100);
    //         $(popover.tip).css('top', `${this.searchedTermPosition.y - heightInProcent}%`);
    //     }
    // }

    private clearPopover(): void {
        const dictElementSelector = '#dictionaryPopoverAnchor';
        if ($(dictElementSelector).length > 0) {
            //@ts-ignore
            bootstrap.Popover.getOrCreateInstance(dictElementSelector).dispose();
        }

        this.searchedTermPosition = undefined;
        $('.popover').remove();
        this.communicationService.announceTermLookUp(undefined);
    }
}
